import {
	isBlank
}
from 'voUtils/tools.js';

import {
	favCount, onFavUpdate
}
from 'voUtils/FavStore.js';

export default {

	data: {
		name: undefined,
	},
	computed: {
		mailto: function () {
			return `mailto:${this.emailAddress}`;
		},
		emailAddress: function () {
			return (VOFFICE.contactEmail || ['info', 'test.de']).join('@');
		}

	},

	mounted: function () {
		onFavUpdate(() => {
			this.$forceUpdate();
		});
		$(".dropdown-toggle").click(function () {
			$(this).next('.dropdown-menu').slideToggle();
		});

		$(window).scroll(function () {
			if ($(window).scrollTop() >= 100) {
				$('nav').addClass('fixed-header');
				$('body').addClass('fixedNav');

			} else {
				$('nav').removeClass('fixed-header');
				$('body').removeClass('fixedNav');

			}
		});

	},

	methods: {


		navbarToggle: function () {

			$('.main-menu').slideToggle();
			$('.navbar-v1').removeClass('open-by-mob');

		},

		favCount: favCount,
		goSearch: function () {
			if (isBlank(this.name)) {
				window.location.href = 's';
			} else {
				window.location.href = 's#?name=' + encodeURIComponent(this.name);
			}
		}



	}


};